import { withStyles } from '@material-ui/core';
import { useState } from 'react';
import CustomTextField from '../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomTextField';
import CustomCheckboxGroupRenderer from '../../../../Dispatch/RouteExecution/DriverPopUp/common/CheckboxGroup';
import styles from './styles';
import Action from '../../common/components/Action';
import { getFieldError, getErrorInfo, isEquipmentUpdateValid } from '../../utils';
import EquipmentDetails from '../../../EditCustomer/components/EquipmentDetails';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../../appConfigContext';
import MESSAGES from '../../../../../../appMessages';
import { withSnackbar } from "notistack";
import { getEquipmentPayloadData, getEquipmentDetails } from '../../../EditCustomer/utils';

const LocationEditForm = (props) => {
  const {
    location,
    onLocationUpdate,
    onCancelEdit,
    classes,
    isNewLocation = false,
    equipmentSizeList,
    selectPolygonOnMap,
    isSelectedOnMap,
    isLocationNameAlreadyExist,
    configJSON
  } = props;
  const [locationName, setLocationName] = useState(location.locationName);
  const [equipmentDetails, setEquipmentDetails] = useState(() =>
    getEquipmentDetails({
      enableFixedEquipmentSize: configJSON.enableFixedEquipmentSize,
      fixedEquipmentSize: location.fixedEquipmentSize,
      maxEquipmentSize: location.maxEquipmentSize,
      minEquipmentSize: location.minEquipmentSize
    })
  );
  const [isLiftGateRequired, setIsLeftGateRequired] = useState(location.isLiftGateRequired);
  const [errors, setErrors] = useState({});

  const handleLocationNameChange = (value) => {
    const isMatchedLocation = isLocationNameAlreadyExist({locationName: value, isNewLocation});
    setLocationName(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      locationName: getFieldError({ fieldName: 'locationName', value, isMatchedLocation })
    }));
  };

  const updateEquipmentSize = (field) => (value) => {
    const equipmentSize = value?.label ?? null;
    const equipmentUpdateDetails = {
      ...equipmentDetails,
      [equipmentDetails.equipmentType]: {
        ...equipmentDetails[equipmentDetails.equipmentType],
        [field]: equipmentSize
      }
    };
    setEquipmentDetails(equipmentUpdateDetails);
  }

  const handleIsLeftGateRequiredChange = () => {
    setIsLeftGateRequired(!isLiftGateRequired);
  };

  const handleLocationSubmit = () => {
    const isMatchedLocation = isLocationNameAlreadyExist({locationName, isNewLocation});
    const errorInfo = getErrorInfo({ locationName }, isMatchedLocation);
    const error = Object.values(errorInfo).filter(Boolean).length;
    if (!isEquipmentUpdateValid(equipmentDetails)) {
      props.enqueueSnackbar(MESSAGES.EQUIPMENT.INVALID_UPDATE['maxEquipmentSize'], {
        variant: "error",
      });
      return;
    }

    if (!error) {
      const { enableFixedEquipmentSize } = configJSON;
      const editedLocation = {
        ...location,
        locationName,
        ...getEquipmentPayloadData({ enableFixedEquipmentSize, equipmentDetails }),
        isLiftGateRequired
      };
      onLocationUpdate(editedLocation);
    } else {
      setErrors(errorInfo);
    }
  };

  const handleEquipmentTypeChange = (value) => {
    const equipmentType = value?.value ?? null;
    if (equipmentDetails.equipmentType === equipmentType) {
      return;
    }
    setEquipmentDetails({equipmentType});
  };

  const clearEquipmentPreference = () => {
    const equipmentUpdateDetails = getEquipmentDetails({
      enableFixedEquipmentSize: null,
      fixedEquipmentSize: null,
      maxEquipmentSize: null,
      minEquipmentSize: null
    });
    setEquipmentDetails(equipmentUpdateDetails);
  };

  return (
    <div
      className={`${classes.container} ${isSelectedOnMap ? classes.highlightedCard : ''}`}
      onClick={() => selectPolygonOnMap([location.locationMappingId])}>
      <CustomTextField
        id="locationName"
        label="Location Name"
        handleChange={handleLocationNameChange}
        value={locationName}
        className={classes.locationName}
        error={errors.locationName}
      />
      <EquipmentDetails
        key={equipmentDetails.equipmentType}
        enabledFixedEquipment={configJSON.enableFixedEquipmentSize}
        handleEquipmentSizeChange={updateEquipmentSize}
        equipmentSizeOptions={equipmentSizeList ?? []}
        handleEquipmentTypeChange={handleEquipmentTypeChange}
        equipmentDetails={equipmentDetails}
        clearEquipmentPreference={clearEquipmentPreference}
      />
      <CustomCheckboxGroupRenderer
        options={[
          {
            name: 'isLiftGateRequired',
            labelText: 'Requires LG',
            isChecked: isLiftGateRequired,
            disabled: false
          }
        ]}
        onChange={handleIsLeftGateRequiredChange}
      />
      <Action
        onClose={onCancelEdit}
        locationMappingId={location.locationMappingId}
        onConfirm={handleLocationSubmit}
        isNewLocation={isNewLocation}
        locationUpdateInProgress={false}
        submitButtonLabel={isNewLocation ? 'Add Location' : 'Update Location'}
      />
    </div>
  );
};

export default compose(withAppConfig, withStyles(styles), withSnackbar)(LocationEditForm);
